import React from 'react';
import './PageLoader.css';

const PageLoader = () => {
  return (
    <div className="page-loader">
      <div className="page-loader-spinner">
        <div className="spinner"></div>
      </div>
      <p className="page-loader-text">Loading...</p>
    </div>
  );
};

export default PageLoader;
